<template>
  <div>
    <v-card class="ma-6 pa-6 pb-0" outlined>
      <BoardingClassClassReportFilter @onFilterChanged="refresh" />
    </v-card>
    <div v-if="action.state === 'select'" class="elevation-0">
      <StudentBlankView :content="'Tìm kiếm'" />
    </div>
    <v-card v-else class="ma-6" outlined>
      <BoardingClassClassReportTable ref="boarding-class-data-table" :filters="filters" :currClass="currClass" />
    </v-card>
  </div>
</template>

<script>
import StudentBlankView from '@/components/basic/StudentBlankView.vue'
import BoardingClassClassReportFilter from './components/BoardingClassClassReportFilter.vue'
import BoardingClassClassReportTable from './components/BoardingClassClassReportTable.vue'

export default {
  components: {
    BoardingClassClassReportTable,
    BoardingClassClassReportFilter,
    StudentBlankView,
  },
  data() {
    return {
      action: {
        state: 'select',
      },
      filters: null,
      currClass: null,
    }
  },
  methods: {
    refresh(query, currClass) {
      this.action.state = 'filtered'
      this.filters = query
      this.currClass = currClass
      this.$nextTick(() => {
        this.$refs['boarding-class-data-table'].searchboardingClassSessionClass()
      })
    },
  },
}
</script>
